module.exports = __webpack_public_path__ + "img/tooltip-vallone-como-gold-02.ab37e34b.jpg";